import React from 'react';
import { useNavigate } from 'react-router-dom';
import './StaticPages.css';
import AdUnit from '../components/AdUnit';

const LandingPage = () => {
  const navigate = useNavigate();
  const isLoggedIn = !!localStorage.getItem('token'); // Adding this line to get loggedin token

  return (
    <div className="static-page">
      <header className="static-header">
        <nav className="static-nav">
          <span className="logo-icon">🔮</span><div className="logo"> Mellodai</div>
          <ul>
            <li><a href="#features">Features</a></li>
            <li><a onClick={() => navigate('/how-it-works')}>How It Works</a></li>
            <li><a onClick={() => navigate('/philosophy')}>Philosophy</a></li>
            <li><a onClick={() => navigate('/method')}>The Method</a></li>
            <li><a onClick={() => navigate('/caregivers')}>For Caregivers</a></li>
            
            <li><a onClick={() => navigate('/blog')}>Blog</a></li>
            <li><a onClick={() => navigate(isLoggedIn ? '/app' : '/login')} className="cta-button">{isLoggedIn ? 'Predictions' : 'Get Started'}</a></li>
          </ul>
        </nav>
      </header>
      {/* Place the AdUnit adsense component here */}
      
      <section className="hero">
        <div className="hero-content">
          <h1>Unlock Your Future with AI-Powered Future Event prediction</h1>
          <p>From ancient oracles to modern AI: Discover what is the next event in life and make informed decisions based of patterns of 25 years of data from 10,000+ individuals</p>
          <div className="hero-buttons">
            <button className="btn-primary" onClick={() => navigate(isLoggedIn ? '/app' : '/login')}>{isLoggedIn ? 'Go to Predictions' : 'Start Free Prediction'}</button>
            <button className="btn-secondary" onClick={() => navigate('/how-it-works')}>Learn How It Works</button>
          </div>
        </div>
      </section>

      <section className="comparison-section"> {/* comparisons section */}
        <div className="comparison-grid">
          <div className="comparison-card">
            <div className="comparison-icon">🎴</div>
            <h3>AI Forecasting vs Tarot</h3>
            <p>If you like tarot readings, discover a data-driven approach that combines the mystique of prediction with the accuracy of science.</p>
          </div>
          <div className="comparison-card">
            <div className="comparison-icon">♈</div>
            <h3>AI Forecasting vs Horoscope</h3>
            <p>If you follow horoscopes, experience predictions backed by 25 years of real data instead of celestial interpretations.</p>
          </div>
          <div className="comparison-card">
            <div className="comparison-icon">🔮</div>
            <h3>AI Forecasting vs Superstition</h3>
            <p>If you're curious about the future, get measured, statistical forecasts based on patterns from 10,000+ real individuals.</p>
          </div>
        </div>
      </section>

      <section id="features">
        <h2 className="section-title">Why Choose Mellodai?</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">🔬</div>
            <h3>Science-Based Predictions</h3>
            <p>Neural Network AI trained on 25 years of real human life events from 10,000+ surveyed individuals.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">📊</div>
            <h3>Statistical Probability</h3>
            <p>Get calculated probabilities, not prophecies. Data-driven insights based on population statistics.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🎯</div>
            <h3>Continuous Learning</h3>
            <p>Our AI model evolves with more data contributions, improving prediction accuracy over time.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🔒</div>
            <h3>Privacy First</h3>
            <p>Prediction results are never stored. Your data is anonymized and used only for calculations.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">⚡</div>
            <h3>Real-Time Forecasting</h3>
            <p>Instant probability calculations based on your unique sequence of life events.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">👨‍👩‍👧‍👦</div>
            <h3>Multi-Persona Support</h3>
            <p>Create predictions for yourself and loved ones. Perfect for parents and caregivers.</p>
          </div>
        </div>
      </section>

      <div className="stats-section">
        <div className="stats-grid">
          <div className="stat-item">
            <h3>10K+</h3>
            <p>Surveyed Individuals</p>
          </div>
          <div className="stat-item">
            <h3>25 Years</h3>
            <p>Historical Data</p>
          </div>
          <div className="stat-item">
            <h3>Neural Net</h3>
            <p>AI Architecture</p>
          </div>
          <div className="stat-item">
            <h3>Real-Time</h3>
            <p>Calculations</p>
          </div>
        </div>
      </div>

      <section className="cta-section">
        <h2>Ready to See Your Statistical Future?</h2>
        <p>Join users making informed life decisions with AI-powered probability insights</p>
        <button className="btn-primary" onClick={() => navigate('/login')}>Try Free Prediction</button>
      </section>
      <section className='headerAd'>
      <AdUnit adSlot="8074484061" /> {/* Use your actual ad slot ID */}
      </section>
      <footer className="static-footer">
        <div className="footer-content">
          <div className="footer-section">
            <h4>Learn More</h4>
            <ul>
              <li><a onClick={() => navigate('/how-it-works')}>How It Works</a></li>
              <li><a onClick={() => navigate('/philosophy')}>Philosophy</a></li>
              <li><a onClick={() => navigate('/method')}>The Method</a></li>
              <li><a onClick={() => navigate('/caregivers')}>For Caregivers</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Resources</h4>
            <ul>
              <li><a onClick={() => navigate('/blog')}>Blog</a></li>
              <li><a onClick={() => navigate('/pricing')}>Pricing</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Legal</h4>
            <ul>
              <li><a onClick={() => navigate('/privacy')}>Privacy Policy</a></li>
              <li><a onClick={() => navigate('/terms')}>Terms of Service</a></li>
              <li><a onClick={() => navigate('/disclaimer')}>Disclaimer</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Company</h4>
            <ul>
              <li><a onClick={() => navigate('/contact')}>Contact</a></li>
              <li><a onClick={() => navigate('/advertise')}>Advertise With Us</a></li>
              <li><a onClick={() => navigate('/faq')}>FAQ</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 Mellodai. All rights reserved. The future, predicted by data.</p>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
